import React from "react";
import { Outlet, useLocation } from "react-router";
import { usePageConfig } from "../../contexts/PageConfigContext";

export const MaintenancePage: React.FC = () => {
  const { setPageConfig } = usePageConfig();
  const location = useLocation();

  React.useEffect(() => {
    const path = location.pathname;
    let title = "Mantenimiento";
    let description: string | undefined = "Equipos, tareas y avisos por Discord";

    if (path.startsWith("/mantenimiento/areas")) {
      title = "Áreas de mantenimiento";
      description = "Cada área tiene su canal de Discord para los avisos";
    } else if (path.startsWith("/mantenimiento/equipos")) {
      title = "Equipos";
      description = "Maquinaria y vehículos sobre los que se programan tareas";
    } else if (path.startsWith("/mantenimiento/tareas")) {
      title = "Tareas de mantenimiento";
      description = "Cambios, revisiones y avisos programados";
    } else if (path.startsWith("/mantenimiento/calendario")) {
      title = "Calendario de mantenimiento";
      description = "Vista mensual de tareas a realizar, filtrable por área";
    }

    setPageConfig({ title, description, actions: [] });
  }, [location.pathname, setPageConfig]);

  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
};
